import { create } from "zustand";
import type { Vector3 } from "@mind-sands/shared";
import { getBoundingBox } from "../engine/meshRegistry";
import type { CinematicStyle, ViewPreset } from "./types";

export interface CameraStore {
  viewPreset: ViewPreset;
  isAnimating: boolean;
  cinematicActive: boolean;
  cinematicStyle: CinematicStyle;
  centerTarget: Vector3 | null;
  homeRequest: number;

  setViewPreset: (preset: ViewPreset) => void;
  setCinematicStyle: (style: CinematicStyle) => void;
  resetCamera: () => void;
  requestHome: () => void;
  cancelAnimation: () => void;
  setAnimating: (animating: boolean) => void;
  setCinematicActive: (active: boolean) => void;
  centerOnObject: (id: string) => void;
  clearCenterTarget: () => void;
}

export const useCameraStore = create<CameraStore>((set) => ({
  viewPreset: "free",
  isAnimating: false,
  cinematicActive: false,
  cinematicStyle: "orbit",
  centerTarget: null,
  homeRequest: 0,

  setViewPreset: (preset) => {
    if (preset === "cinematic") {
      set({
        viewPreset: "cinematic",
        isAnimating: false,
        cinematicActive: true,
      });
    } else {
      set({
        viewPreset: "free",
        isAnimating: false,
        cinematicActive: false,
      });
    }
  },

  resetCamera: () => {
    set((state) => ({
      viewPreset: "free",
      isAnimating: false,
      cinematicActive: false,
      homeRequest: state.homeRequest + 1,
    }));
  },

  requestHome: () => {
    set((state) => ({
      homeRequest: state.homeRequest + 1,
      viewPreset: "free",
      isAnimating: false,
      cinematicActive: false,
    }));
  },

  cancelAnimation: () => {
    set({
      isAnimating: false,
      viewPreset: "free",
      cinematicActive: false,
    });
  },

  setAnimating: (animating) => set({ isAnimating: animating }),
  setCinematicActive: (active) => set({ cinematicActive: active }),
  setCinematicStyle: (style) => set({ cinematicStyle: style }),

  centerOnObject: (id) => {
    const bb = getBoundingBox(id);
    if (bb) {
      set({ centerTarget: bb.center });
    }
  },

  clearCenterTarget: () => set({ centerTarget: null }),
}));
